import React from 'react';
import { Spinner } from 'react-activity';
import 'react-activity/dist/library.css';

const Loader = () => (
  <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 flex items-center justify-center z-[1500]">
    <Spinner size={30} color="white" />
  </div>
);

export default Loader;
